import styled from "styled-components";
import ProfileItem from "./ProfileItem";

function Profile(){
    return(
        <Container>
            <PartName>고객 PROFILE</PartName>
            <BookList>
                <ProfileItem image={"https://shopping-phinf.pstatic.net/main_4292667/42926672636.20230928201741.jpg?type=w300"}
                    name={"계절의 한 켠"}
                    writer={"늘해랑,서혜안,안동균,이보라,이아름,함인희"}
                    publisher={"모던북스"}
                    publishedDate={"2023.09.25."}
                />
                <ProfileItem image={"https://shopping-phinf.pstatic.net/main_4368008/43680082619.20231102070839.jpg?type=w300"}
                    name={"길 위에서"}
                    writer={"김하나,권소영,이안,한량,한세희"}
                    publisher={"모던북스"}
                    publishedDate={"2023.10.27."}
                />
                <ProfileItem image={"https://shopping-phinf.pstatic.net/main_4461162/44611620626.20231212192705.jpg?type=w300"}
                    name={"사유의 시간"}
                    writer={"김자영,김혜미,서은숙,유탈,이해영,지유민..."}
                    publisher={"모던북스"}
                    publishedDate={"2023.11.30."}
                />
            </BookList>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 60px;
`

const PartName = styled.div`
    font-size: 24px;
    font-weight: 700;
    color: #58AC65;
`


const BookList = styled.div`
    display: grid;
    justify-content: space-between;
    gap: 30px;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    justify-items: center; /* Center items horizontally in the grid */

    @media (max-width: 1024px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 768px) {
        grid-template-columns: repeat(1, 1fr);
    }
`


export default Profile;